// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCM2KxoLkcsyhjIOUlzJ9EXKFWM6cW9ft0",
  authDomain: "digiseq-manage-mii.firebaseapp.com",
  databaseURL: "https://digiseq-manage-mii.firebaseio.com",
  projectId: "digiseq-manage-mii",
  storageBucket: "digiseq-manage-mii.firebasestorage.app",
  messagingSenderId: "76983131674",
  appId: "1:76983131674:web:92f978e0ba2b16eac73ba3",
  measurementId: "G-M8KPM88H8B",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const analytics = await isSupported().then((yes) => {
  const instance = getAnalytics(app);

  // Enable debug mode for local development
  if (window.location.hostname === "localhost") {
    window["ga-disable-" + firebaseConfig.measurementId] = false;
    instance._query = "debug_mode=1"; // tells Firebase to route to DebugView
  }

  return instance;
});

export { app, analytics };
